import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconEditOutlineSvg } from "./IconEditOutlineSvg.mjs";
const IconEditOutline = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconEditOutlineSvg, ...iconProps });
};
export {
  IconEditOutline
};
